import { Country } from '@typings/operations';

export const getCountryById = (countries: Array<Country>, countryId: string) =>
  countries.filter(({ id }) => countryId === id)[0];
